import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * {Props}
 * calloutTrigger:
 *   the visual component/element that triggers the callout, wrapped by the
 *   button with the click handler
 * children:
 *   the toggleable callout
 * show:
 *   boolean, indicates whether the callout should be shown,
 * size:
 *   a set of sizes for the callout, which map to styles, if you want it to be
 *   sized according to content, use 'auto'
 * offsetX:
 *   horizontal axis offset, useful for more precise positioning,
 * offsetY:
 *   vertical axis offset useful for more precise positioning,
 * indicatorPosition:
 *   position of indicator triangle in relation to trigger
 * togglePresent:
 *   callback to be fired on interaction with trigger, controls presentation of
 *   callout
 * classModifier:
 *   modifier to add a class for styling tweaks
 */
export default class Callout extends Component {
  static propTypes = {
    calloutTrigger: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.object,
      PropTypes.func,
    ]).isRequired,
    size: PropTypes.oneOf([
      'auto',
      'small',
      'medium',
      'large',
    ]),
    offsetX: PropTypes.number,
    offsetY: PropTypes.number,
    indicatorPosition: PropTypes.oneOf([
      'top-left',
      'top-center',
      'top-right',
    ]),
    togglePresent: PropTypes.func,
    classModifier: PropTypes.string,
    show: PropTypes.bool,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    size: null,
    indicatorPosition: null,
    togglePresent: () => null,
    offsetX: 0,
    offsetY: 0,
    classModifier: null,
    show: false,
  };

  getCalloutClasses() {
    return classNames(
      'callout-inner', {
        '--auto': this.props.size === 'auto',
        '--small': this.props.size === 'small',
        '--medium': this.props.size === 'medium',
        '--large': this.props.size === 'large',
        '--indicator-top-left': this.props.indicatorPosition === 'top-left',
        '--indicator-top-center': this.props.indicatorPosition === 'top-center',
        '--indicator-top-right': this.props.indicatorPosition === 'top-right',
      },
    );
  }

  render() {
    return (
      <div className="callout">
        <button
          type="button"
          className={classNames('callout-toggle-button', this.props.classModifier)}
          onClick={() => this.props.togglePresent()}
        >
          {this.props.calloutTrigger}
        </button>
        {this.props.show && (
          <div className={this.getCalloutClasses()} style={{ transform: `translateY(${this.props.offsetY}px) translateX(${this.props.offsetX}px)` }}>
            {this.props.children}
            <span className="callout-indicator" />
          </div>
        )}
      </div>
    );
  }
}
